import React from 'react';
import { Field } from 'redux-form';
import classnames from 'classnames';

const getData = (keyword, description) => {
  const defaultValue = {
    label: keyword,
    tagDescription: description,
    image: keyword.replace(' ', '-').toLowerCase(),
    overlayColor: 'black'
  };
  switch (keyword) {
    case 'news':
      return {
        ...defaultValue,
        overlayColor: 'red'
      };
    case 'entertainment':
      return {
        label: 'Entertainment',
        image: 'entertainment',
        tagDescription:
          'Entertainment: news, gossip, celebrities, music, cinema and more',
        overlayColor: 'purple'
      };
    case 'smart':
      return {
        label: 'Trending',
        image: 'trending',
        tagDescription:
          'Trivia, science and pop culture. Excellent for younger audiences',
        overlayColor: 'yellow-blue'
      };
    case 'viral':
      return {
        ...defaultValue,
        overlayColor: 'azure'
      };
    case 'tech':
      return {
        ...defaultValue,
        label: 'Technology',
        overlayColor: 'blue'
      };
    case 'lifestyle':
      return {
        ...defaultValue,
        overlayColor: 'yellow'
      };
    case 'sports':
      return {
        ...defaultValue,
        overlayColor: 'yellow'
      };
    case 'notif1':
      return {
        label: 'Notifications important',
        image: 'notifications-important',
        tagDescription:
          'News of the day, sports, finance and tech, optimized for notifications',
        overlayColor: 'red'
      };
    case 'notif2':
      return {
        label: 'Notifications light',
        tagDescription: 'Entertainment and fun, optimized for notifications',
        overlayColor: 'purple'
      };
    case 'one':
      return {
        ...defaultValue,
        overlayColor: 'green'
      };
    case 'health':
      return {
        ...defaultValue,
        overlayColor: 'purple'
      };
    case 'finance':
      return {
        ...defaultValue,
        overlayColor: 'green'
      };
    case 'crypto':
      return {
        ...defaultValue,
        tagDescription: 'Articles about Bitcoin and other cryptocurrency',
        overlayColor: 'blue'
      };
    default:
      return defaultValue;
  }
};

const TagsImageRadio = ({ name, options, disabled }) => (
  <div className="radio-img-wrap">
    <Field
      component={({ input, options = [] }) => {
        if (options.length === 0) {
          return <span>No tags</span>;
        }
        return options.map(({ keyword = '', description, tags, image }) => {
          keyword = keyword.toLowerCase();
          const { overlayColor, tagDescription, label } = getData(
            keyword,
            description
          );
          const value = tags.join(',');
          return (
            <label
              key={keyword}
              className={classnames('image-radio-btn radio-btn', { disabled })}
            >
              <div className="tag-image">
                <img src={image} alt={keyword} />
                <div
                  className={classnames(
                    'overlay-image',
                    'overlay-' + overlayColor
                  )}
                />
              </div>
              <input
                className="radio-btn__radio"
                type="radio"
                id={keyword}
                {...input}
                value={value}
                disabled={disabled}
                checked={value === input.value}
              />
              <span className="radio-btn__radio-custom" />
              <div className="tag-label">{label}</div>
              <div className="tag-description">{tagDescription}</div>
            </label>
          );
        });
      }}
      name={name}
      options={options}
    />
  </div>
);

export default TagsImageRadio;



// WEBPACK FOOTER //
// ./src/components/formFields/TagsImageRadio.js